const dictionary = {
	"ja": {
		'現在のカートの中身を空にしますか？': '現在のカートの中身を空にしますか？',
		'閉じる': '閉じる',
		'キャンセル': 'キャンセル',
		'戻る': '戻る',
		'カートに入れる': 'カートに入れる',
		'決定': '決定',
		'ご注文内容': 'ご注文内容',
		'削除': '削除',
		'カートを空にする': 'カートを空にする',
		'他のメニューを選ぶ': '他のメニューを選ぶ',
		'カテゴリ': 'カテゴリ',
		'会計': '会計',
		'前の': '前の',
		'次へ': '次へ',
		'注文': '注文',
		'※必須': '※必須',
		'おすすめ': 'おすすめ',
		'メニュー': 'メニュー',
		'ログイン': 'ログイン',
		'合計価格': '合計価格',
		'注文する': '注文する',
    	'注文履歴': '注文履歴',
    	'特定商取引に基づく表記': '特定商取引に基づく表記',
		'カート': 'カート',
		'注文エラー': '注文エラー',
		'メニュー選択に戻る': 'メニュー選択に戻る',
		'注文するには少なくとも\n1つのアイテムを選択してください': '注文するには少なくとも\n1つのアイテムを選択してください',
		'サーバーへの接続に問題が発生しています。': 'サーバーへの接続に問題が発生しています。',
		'ご注文、ありがとうございます。ご注文を承りました。': 'ご注文、ありがとうございます。ご注文を承りました。',
		'はい': 'はい',
		'いいえ': 'いいえ',
		'合計': '合計',
		'品': '品',
		'注文を確認': '注文を確認',
		'メニューカテゴリ': 'メニューカテゴリ',
		'数量': '数量',
		'商品': '商品',
		'品の注文が未送信です': '品の注文が未送信です',
		'注文を確認する': '注文を確認する',
		'ありがとうございました。\nしばらくお待ちください。': 'ありがとうございました。\nしばらくお待ちください。',
		'注文を承りました': '注文を承りました',
		"エラーが発生しました": "エラーが発生しました",
		'エラー': 'エラー',
		'数量が入力されていません。': '数量が入力されていません。',
		'の数量があいません。': 'の数量があいません。',
		'システムエラー': 'システムエラー',
		'エラーが発生しました。\nmissing table_id. need realod url': 'エラーが発生しました。\nテーブルidが見つかりません。\n再接続してください。',
		'現在はオーダー履歴の閲覧ができません\n未着席状態': '現在はオーダー履歴の閲覧ができません\n未着席状態',
		'お受け取り希望時間': 'お受け取り希望時間',
		'時間を選択': '時間を選択',
		'受け取り時間を選択してください': '受け取り時間を選択してください',
		'通知方法': '通知方法',
		'通知の受け取り方法を選択してください': '通知の受け取り方法を選択してください',
		'メールアドレスを入力してください': 'メールアドレスを入力してください',
		'メールアドレスの形式が正しくありません': 'メールアドレスの形式が正しくありません',
		'メールアドレスは半角英数字・記号で入力してください': 'メールアドレスは半角英数字・記号で入力してください',
		'電話番号を入力してください': '電話番号を入力してください',
		'電話番号を半角数字(ハイフン無し)で入力してください': '電話番号を半角数字(ハイフン無し)で入力してください',
		'備考がありましたら入力してください': '備考がありましたら入力してください',
		'受け取り時間':'受け取り時間',
		'お届け希望時間':'お届け希望時間',
		'通知先':'通知先',
		'電話番号':'電話番号',
		'お名前':'お名前',
		'配達可能エリア':'配達可能エリア',
		'お届け先の郵便番号':'お届け先の郵便番号',
		'お届け先の住所':'お届け先の住所',
		'備考':'備考',
		'追加する':'追加する',
		'合計金額':'合計金額',
		'現在利用できません。':'現在利用できません。',
		'こちらの内容でお支払いします':'こちらの内容で\nお支払いします',
		'必須項目を入力してください':'必須項目を\n入力してください',
		'希望時間が\n過ぎています':'希望時間が\n過ぎています',
		'申し訳ございませんが、\n希望時間を再設定してください。':'申し訳ございませんが、\n希望時間を再設定してください。',
		'を開きます。よろしいですか？':'を開きます。よろしいですか？',
		'ご利用ありがとうございました\nまたのご利用をお待ちしております。':'ご利用ありがとうございました\nまたのご利用をお待ちしております。',
		'受付番号': '受付番号',
		'お会計が完了していません。': 'お会計が完了していません。',
		'ご利用ありがとうございました。': 'ご利用ありがとうございました。',
		'ご希望の受け取り時間': 'ご希望の受け取り時間',
		'まだお店側が受け取り時間を設定していません。': 'まだお店側が受け取り時間を設定していません。',
		'受け取り予定時間': '受け取り予定時間',
		'指定のお時間に受け取りに来てください。そして受付番号をお伝えください。': '指定のお時間に受け取りに来てください。そして受付番号をお伝えください。',
		'準備完了の通知が届きましたら受け取りに来てください。そして受付番号をお伝えください。': '準備完了の通知が届きましたら受け取りに来てください。そして受付番号をお伝えください。',
		'更新':'更新',
		'ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください':'ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください',
		'お受け取り希望時間を入力してください':'お受け取り希望時間を入力してください',
		'会計済みです':'会計済みです',
		'こちらの内容で承ります':'こちらの内容で\n承ります',
		'受け取り方法を選択してください': '受け取り方法を\n選択してください',
		'お店で受け取り': 'お店で受け取り',
		'ご指定の住所にお届け': 'ご指定の住所にお届け',
		'ご希望の通知方法': 'ご希望の通知方法',
		'お名前を入力してください': 'お名前を入力してください',
		'お名前は50文字以内で入力してください': 'お名前は50文字以内で入力してください',
		'お名前に記号は使用出来ません': 'お名前に記号は使用出来ません',
		'郵便番号を入力してください': '郵便番号を入力してください',
		'郵便番号は半角数字で入力してください': '郵便番号は半角数字で入力してください',
		'郵便番号7桁で入力してください': '郵便番号7桁で入力してください',
		'住所を入力してください': '住所を入力してください',
		'お支払い方法を選択してください': 'お支払い方法を選択してください',
		'ご希望のお届け時間': 'ご希望のお届け時間',
		'まだお店側がお届け時間を設定していません。': 'まだお店側がお届け時間を設定していません。',
    	'お届け予定時間': 'お届け予定時間',
		'お届け希望時間を選択してください': 'お届け希望時間を選択してください',
		'配達料':'配達料',
		'アプリ会員ID': 'アプリ会員ID',
		'アプリ会員IDを入力してください': 'アプリ会員IDを入力してください',
	},
	"zh-Hans": {
		'現在のカートの中身を空にしますか？': '您要清空当前的购物车内容吗？',
		'閉じる': '关闭',
		'キャンセル': '取消',
		'戻る': '回报',
		'カートに入れる': '加入购物车',
		'決定': '結晶',
		'ご注文内容': '订单详情',
		'削除': '删除',
		'カートを空にする': '清空推车',
		'他のメニューを選ぶ': '选择其他菜单',
		'カテゴリ': '类别',
		'会計': '结账',
		'前の': '前面的',
		'次へ': '下一个',
		'注文': '订单',
		'※必須': '※必须',
		'おすすめ': '推荐',
		'メニュー': '菜单',
		'ログイン': '登录',
		'合計価格': '总计价格',
		'注文する': '下单',
    	'注文履歴': '订单历史记录',
    	'特定商取引に基づく表記': '基於特定商業交易法的註釋',
		'カート': '订单发送',
		'注文エラー': '订单出错',
		'メニュー選択に戻る': '返回菜单选择',
		'注文するには少なくとも\n1つのアイテムを選択してください': '请选择至少一件商品才能下单',
		'サーバーへの接続に問題が発生しています。': '连接服务器出错',
		'ご注文、ありがとうございます。ご注文を承りました。': '感谢您的订购\n您的订单已被受理',
		'はい': '是的',
		'いいえ': '没有啦',
		'合計': '合计',
		'品': '货品',
		'注文を確認': '确认订单',
		'メニューカテゴリ': '菜单类别',
		'数量': '数量',
		'商品': '大宗商品',
		'品の注文が未送信です': '产品订单尚未发送',
		'注文を確認する': '确认订单',
		'ありがとうございました。\nしばらくお待ちください。': '非常感谢你\n请稍等',
		'注文を承りました': '我收到订单',
		"エラーが発生しました": "发生了错误",
		'エラー': '失误',
		'数量が入力されていません。': '数量尚未输入',
		'の数量があいません。': '数量不足',
		'システムエラー': '系统错误',
		'エラーが発生しました。\nmissing table_id. need realod url': '发生了错误\n找不到表格ID。\n请重新连接。',
		'現在はオーダー履歴の閲覧ができません\n未着席状態': '目前无法查看订单历史记录\n未就座',
		'お受け取り希望時間': '接送时间',
		'時間を選択': '选择时间',
		'受け取り時間を選択してください': '请选择接送时间',
		'通知方法': '通知方式',
		'通知の受け取り方法を選択してください': '选择您要如何接收通知',
		'メールアドレスを入力してください': '请输入您的电子邮件地址',
		'メールアドレスの形式が正しくありません': '输入一个有效的电子邮件地址',
		'メールアドレスは半角英数字・記号で入力してください': '请使用单字节字母数字字符和符号输入您的电子邮件地址',
		'電話番号を入力してください': '请输入电话号码',
		'電話番号を半角数字(ハイフン無し)で入力してください': '请使用半角数字输入电话号码（不带连字符）',
		'備考がありましたら入力してください': '请输入其他要求',
		'受け取り時間':'接送时间',
		'お届け希望時間': '所需的交货时间',
		'通知先':'通知目的地',
		'お名前':'名称',
		'配達可能エリア':'交货地区',
		'お届け先の郵便番号': '邮政编码',
		'お届け先の住所': '街道地址',
		'電話番号':'电话号码',
		'備考':'备注',
		'合計金額':'总金额',
		'追加する':'新增',
		'現在利用できません。':'目前不可用',
		'こちらの内容でお支払いします':'以这个内容结算',
		'必須項目を入力してください':'请输入必填字段',
		'希望時間が\n過ぎています':'超过订购时间',
		'申し訳ございませんが、\n希望時間を再設定してください。':'超过了订购时间的接送时间。\n请再次选择接客时间。',
		'を開きます。よろしいですか？':'开门你确定吗',
		'ご利用ありがとうございました\nまたのご利用をお待ちしております。':'感谢您使用\n我们期待您的下一次使用',
		'受付番号': '接待号码',
		'お会計が完了していません。': '结帐未完成',
		'ご利用ありがとうございました。': '感谢您的使用',
		'ご希望の受け取り時間': '所需的接送时间',
		'まだお店側が受け取り時間を設定していません。': '商店尚未设定提货时间',
		'受け取り予定時間': '预计接收时间',
		'指定のお時間に受け取りに来てください。そして受付番号をお伝えください。': '请在指定时间来接您。并请提供您的接待号码。',
		'準備完了の通知が届きましたら受け取りに来てください。そして受付番号をお伝えください。': '当您收到准备通知时，请过来取货。并请提供您的接待号码。',
		'更新':'更新资料',
		'ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください':'谢谢您的订购。请稍等片刻，然后再上菜。 \n如果您需要收据，请向负责人显示此屏幕',
		'お受け取り希望時間を入力してください':'请输入您的接送时间',
		'会計済みです':'已结帐',
		'受け取り方法を選択してください': '請選擇送貨方式',
		'お店で受け取り': '在商店取貨',
		'ご指定の住所にお届け': '送貨到您指定的地址',
		'ご希望の通知方法': '所需的通知方法',
		'お名前を入力してください': '請輸入你的名字',
		'お名前は50文字以内で入力してください': '请输入您的姓名（不超过50个字符）',
		'お名前に記号は使用出来ません': '您不能在名称中使用符号',
		'郵便番号を入力してください': '請輸入您的郵編',
		'郵便番号は半角数字で入力してください': '請用半角字符輸入郵政編碼',
		'郵便番号7桁で入力してください': '輸入7位數的郵政編碼',
		'住所を入力してください': '請輸入您的地址',
		'お支払い方法を選択してください': '請選擇付款方式',
		'ご希望のお届け時間': '所需的交貨時間',
		'まだお店側がお届け時間を設定していません。': '店鋪尚未設定送貨時間',
    	'お届け予定時間': '預計送達時間',
		'お届け希望時間を選択してください': '請選擇所需的交貨時間',
		'配達料':'快递费',
		'アプリ会員ID': '應用程式會員編號',
		'アプリ会員IDを入力してください': '請輸入應用會員ID',
	},
	"zh-Hant": {
		'現在のカートの中身を空にしますか？': '您要清空當前的購物車內容嗎？',
		'閉じる': '關閉',
		'キャンセル': '取消',
		'戻る': '回報',
		'カートに入れる': '加入購物車',
		'決定': '结晶',
		'ご注文内容': '訂單詳情',
		'削除': '刪除',
		'カートを空にする': '清空推車',
		'他のメニューを選ぶ': '選擇其他菜單',
		'カテゴリ': '類別',
		'会計': '結帳',
		'前の': '前面的',
		'次へ': '下一個',
		'注文': '訂單',
		'※必須': '※必須',
		'おすすめ': '推薦',
		'メニュー': '菜單',
		'ログイン': '登錄',
		'合計価格': '總計價格',
		'注文する': '下單',
    	'注文履歴': '訂單歷史記錄',
    	'特定商取引に基づく表記': '基于特定商业交易法的注释',
		'カート': '訂單發送',
		'注文エラー': '訂單出錯',
		'メニュー選択に戻る': '返回菜單選擇',
		'注文するには少なくとも\n1つのアイテムを選択してください': '請選擇至少一件商品才能下單',
		'サーバーへの接続に問題が発生しています。': '連接伺服器出錯',
		'ご注文、ありがとうございます。ご注文を承りました。': '感謝您的訂購\n您的訂單已被受理',
		'はい': '是的',
		'いいえ': '没有啦',
		'合計': '合計',
		'品': '貨品',
		'注文を確認': '確認訂單',
		'メニューカテゴリ': '菜單類別',
		'数量': '數量',
		'商品': '大宗商品',
		'品の注文が未送信です': '產品訂單尚未發送',
		'注文を確認する': '確認訂單',
		'ありがとうございました。\nしばらくお待ちください。': '非常感謝你\n請稍等',
		'注文を承りました': '我收到訂單',
		"エラーが発生しました": "發生了錯誤",
		'エラー': '失誤',
		'数量が入力されていません。': '數量尚未輸入',
		'の数量があいません。': '數量不足',
		'システムエラー': '系統錯誤',
		'エラーが発生しました。\nmissing table_id. need realod url': '發生了錯誤\n找不到表格ID。\n請重新連接。',
		'現在はオーダー履歴の閲覧ができません\n未着席状態': '目前無法查看訂單歷史記錄\n未就座',
		'お受け取り希望時間': '接送時間',
		'時間を選択': '選擇時間',
		'受け取り時間を選択してください': '請選擇接送時間',
		'通知方法': '通知方式',
		'通知の受け取り方法を選択してください': '選擇您要如何接收通知',
		'メールアドレスを入力してください': '請輸入您的電子郵件地址',
		'メールアドレスの形式が正しくありません': '輸入一個有效的電子郵件地址',
		'メールアドレスは半角英数字・記号で入力してください': '請使用單字節字母數字字符和符號輸入您的電子郵件地址',
		'電話番号を入力してください': '請輸入電話號碼',
		'電話番号を半角数字(ハイフン無し)で入力してください': '請使用半角數字輸入電話號碼（不帶連字符）',		
		'備考がありましたら入力してください': '請輸入其他要求',
		'受け取り時間':'接送時間',
		'お届け希望時間': '所需的交貨時間',
		'通知先':'通知目的地',
		'お名前':'名稱',
		'配達可能エリア':'交貨地區',
		'お届け先の郵便番号': '郵政編碼',
		'お届け先の住所': '街道地址',
		'電話番号':'電話號碼',
		'備考':'備註',
		'合計金額':'總金額',
		'追加する':'新增',
		'現在利用できません。':'目前不可用',
		'こちらの内容でお支払いします':'以這個內容結算',
		'必須項目を入力してください':'請輸入必填字段',
		'希望時間が\n過ぎています':'超過訂購時間',
		'申し訳ございませんが、\n希望時間を再設定してください。':'超過了訂購時間的接送時間。\n請再次選擇接客時間。',
		'を開きます。よろしいですか？':'開門你確定嗎',
		'ご利用ありがとうございました\nまたのご利用をお待ちしております。':'感謝您使用\n我們期待您的下一次使用',
		'受付番号':'接待號碼',
		'お会計が完了していません。': '結帳未完成',
		'ご利用ありがとうございました。': '感謝您的使用',
		'ご希望の受け取り時間': '所需的接送時間',
		'まだお店側が受け取り時間を設定していません。': '商店尚未設定提貨時間',
		'受け取り予定時間': '預計接收時間',
		'指定のお時間に受け取りに来てください。そして受付番号をお伝えください。': '請在指定時間來接您。並請提供您的接待號碼。',
		'準備完了の通知が届きましたら受け取りに来てください。そして受付番号をお伝えください。': '當您收到準備通知時，請過來取貨。并请提供您的接待号码。',
		'更新':'更新資料',
		'ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください':'謝謝您的訂購。請稍等片刻，然後再上菜。 \n如果您需要收據，請向負責人顯示此屏幕',
		'お受け取り希望時間を入力してください':'請輸入您的接送時間',
		'会計済みです':'已結帳',
		'受け取り方法を選択してください': '请选择送货方式',
		'お店で受け取り': '在商店取货',
		'ご指定の住所にお届け': '送货到您指定的地址',
		'ご希望の通知方法': '首选通知方式',
		'お名前を入力してください': '请输入你的名字',
		'お名前は50文字以内で入力してください': '請輸入您的姓名（不超過50個字符）',
		'お名前に記号は使用出来ません': '您不能在名稱中使用符號',
		'郵便番号を入力してください': '请输入您的邮编',
		'郵便番号は半角数字で入力してください': '请用半角字符输入邮政编码',
		'郵便番号7桁で入力してください': '输入7位数的邮政编码',
		'住所を入力してください': '请输入您的地址',
		'お支払い方法を選択してください': '请选择付款方式',
		'ご希望のお届け時間': '所需的交货时间',
		'まだお店側がお届け時間を設定していません。': '店铺尚未设定送货时间',
    	'お届け予定時間': '预计送达时间',
		'お届け希望時間を選択してください': '请选择所需的交货时间',
		'配達料':'快遞費',
		'アプリ会員ID': '应用程式会员编号',
		'アプリ会員IDを入力してください': '请输入应用会员ID',
	},
	"ko": {
		'現在のカートの中身を空にしますか？': '미주문 내용을 삭제 하시겠습니까?',
		'閉じる': '닫기',
		'キャンセル': '취소',
		'戻る': '돌아 가기',
		'カートに入れる': '장바구니에 담기',
		'決定': '결정',
		'ご注文内容': '주문 내용',
		'削除': '삭제',
		'カートを空にする': '장바구니 비우기',
		'他のメニューを選ぶ': '다른 메뉴를 선택',
		'カテゴリ': '카테고리',
		'会計': '계산',
		'前の': '이전',
		'次へ': '다음',
		'注文': '주문',
		'※必須': '※필수',
		'おすすめ': '추천',
		'メニュー': '메뉴',
		'ログイン': '로그인',
		'合計価格': '합계가격',
		'注文する': '주문',
    	'注文履歴': '주문이력',
    	'特定商取引に基づく表記': '특정 상거래 법에 근거한 표기',
		'カート': '주문송신',
		'注文エラー': '주문오류',
		'メニュー選択に戻る': '메뉴선택으로 복귀',
		'注文するには少なくとも\n1つのアイテムを選択してください': '주문하실 때 최소한 한 개의 품목을 선택해 주십시오',
		'サーバーへの接続に問題が発生しています。': '서버 접속에 문제가 발생했습니다',
		'ご注文、ありがとうございます。ご注文を承りました。': '주문해주셔서 감사합니다\n 주문이 완료되었습니다',
		'はい': '네',
		'いいえ': '아니오',
		'合計': '총',
		'品': '제품',
		'注文を確認': '주문 확인',
		'メニューカテゴリ': '메뉴 카테고리',
		'数量': '수량',
		'商品': '상품',
		'品の注文が未送信です': '주문이 송신되지 않았습니다',
		'注文を確認する': '주문을 확인',
		'ありがとうございました。\nしばらくお待ちください。': '감사합니다\n기다려주십시오',
		'注文を承りました': '주문이 접수되었습니다',
		"エラーが発生しました": "오류가 발생했습니다",
		'エラー': '오류',
		'数量が入力されていません。': '수량이 입력되어 있지 않습니다',
		'の数量があいません。': '수량이 일치하지 않습니다',
		'システムエラー': '시스템 오류',
		'エラーが発生しました。\nmissing table_id. need realod url': '오류가 발생했습니다\n테이블 ID를 찾을 수 없습니다.\n다시 연결해 주십시오.',
		'現在はオーダー履歴の閲覧ができません\n未着席状態': '현재는 주문 내역 조회 수 없습니다.\n미 착석 상태',
		'お受け取り希望時間': '수령 희망 시간',
		'時間を選択': '시간을 선택',
		'受け取り時間を選択してください': '수령 희망 시간을 선택하십시오',
		'通知方法': '알림 수신 방법',
		'通知の受け取り方法を選択してください': '알림 수신 방법을 선택해 주십시오',
		'メールアドレスを入力してください': '이메일 주소를 입력해 주십시오',
		'メールアドレスの形式が正しくありません': '유효한 이메일 주소를 입력해 주십시오',
		'メールアドレスは半角英数字・記号で入力してください': '이메일 주소는 영숫자 · 기호 입력',
		'電話番号を入力してください': '전화 번호를 입력해 주십시오',
		'電話番号を半角数字(ハイフン無し)で入力してください': '전화 번호를 반각 숫자 (하이픈 없음)로 입력',		
		'備考がありましたら入力してください': '그 외 요구사항이 있으시면 입력해 주십시오',
		'受け取り時間':'수령시간',
		'お届け希望時間': '배달 희망 시간',
		'通知先':'연락처',
		'お名前':'이름',
		'配達可能エリア':'배달가능지역',
		'お届け先の郵便番号': '우편 번호',
		'お届け先の住所': '주소',
		'電話番号': '전화번호',
		'備考':'요구사항',
		'合計金額':'합계금액',
		'追加する':'추가',
		'現在利用できません。':'현재 사용할 수 없습니다',
		'こちらの内容でお支払いします':'이 내용으로\n결제합니다',
		'必須項目を入力してください':'필수 항목을 입력해 주십시오',
		'希望時間が\n過ぎています':'주문 가능\n시간 초과',
		'申し訳ございませんが、\n希望時間を再設定してください。':'주문 가능 시간이 초과되었습니다. \n시간을 다시 선택해 주십시오.',
		'を開きます。よろしいですか？':'를 엽니다. 하시겠습니까?',
		'ご利用ありがとうございました\nまたのご利用をお待ちしております。':'이용해 주셔서 감사합니다. \n또한 이용을 기다리고 있습니다.',
		'指定のお時間に受け取りに来てください。そして受付番号をお伝えください。': '지정 시간에 받으러 와주세요. 그리고 접수 번호를 알려주십시오',
		'準備完了の通知が届きましたら受け取りに来てください。そして受付番号をお伝えください。': '준비완료의 연락이 도착하시면 받으러 와주세요. 그리고 접수 번호를 알려주십시오.',
		'お会計が完了していません。': '결제가 완료되지 않습니다',
		'ご利用ありがとうございました。': '이용해 주셔서 감사합니다',
		'ご希望の受け取り時間': '희망의 수신 시간',
		'まだお店側が受け取り時間を設定していません。': '아직 가게 측이 수신 시간을 설정하지 않습니다',
		'受け取り予定時間': '수신 예정 시간',
		'更新':'업데이트',
		'ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください':'주문 감사합니다. 요리 제공까지 기다려주십시오. \n 영수증이 필요하신 분은이 화면을 담당 자에게 보여주십시오',
		'お受け取り希望時間を入力してください':'수령 희망 시간을 입력하십시오',
		'会計済みです':'결제되었습니다',
		'受け取り方法を選択してください': '수령 방법을 선택하십시오',
		'お店で受け取り': '가게에서 받아',
		'ご指定の住所にお届け': '지정 주소로 배송',
		'ご希望の通知方法': '원하는 통지 방법	3',
		'お名前を入力してください': '이름을 입력하십시오',
		'お名前は50文字以内で入力してください': '이름은 50 자 이내로 입력하십시오',
		'お名前に記号は使用出来ません': '이름에 기호는 사용할 수 없습니다',
		'郵便番号を入力してください': '우편 번호를 입력하십시오',
		'郵便番号は半角数字で入力してください': '우편 번호는 숫자로만 입력',
		'郵便番号7桁で入力してください': '우편 번호는 7 자리로 입력하십시오',
		'住所を入力してください': '주소를 입력하십시오',
		'お支払い方法を選択してください': '결제 방법을 선택하십시오',
		'ご希望のお届け時間': '희망 배달 시간',
		'まだお店側がお届け時間を設定していません。': '가게 측이 전해 시간을 설정하지 않습니다',
    	'お届け予定時間': '배송 예정 시간',
		'お届け希望時間を選択してください': '배송 희망 시간을 선택하십시오',
		'配達料':'배달요금',
		'アプリ会員ID': '앱 회원 ID',
		'アプリ会員IDを入力してください': '앱 회원 ID를 입력하십시오',
	},
	"en": {
		'現在のカートの中身を空にしますか？': 'Do you want to empty the current cart contents?',
		'閉じる': 'Close',
		'キャンセル': 'Cancel',
		'戻る': 'Previous',
		'カートに入れる': 'Add to cart',
		'決定': 'Order',
		'ご注文内容': 'Order details',
		'削除': 'Delete',
		'カートを空にする': 'Empty the cart',
		'他のメニューを選ぶ': 'Choose another menu',
		'カテゴリ': 'Category',
		'会計': 'Check',
		'前の': 'Previous',
		'次へ': 'Next',
		'注文': 'Order',
		'※必須': '※Required',
		'おすすめ': 'Recommentd',
		'メニュー': 'Menu',
		'ログイン': 'Login',
		'合計価格': 'Total Price',
		'注文する': 'Order',
		'注文履歴': 'Order History',
    	'注文送信': 'Send Order',
    	'特定商取引に基づく表記': 'Notation based on Specified Commercial Transaction Law',
		'カート': 'Cart',
		'注文エラー': 'Order Error',
		'メニュー選択に戻る': 'Return to menu selection',
		'注文するには少なくとも\n1つのアイテムを選択してください': 'Please select at least one item to order',
		'サーバーへの接続に問題が発生しています。': 'There is a problem connecting to the server',
		'ご注文、ありがとうございます。ご注文を承りました。': 'Thank you for your order.\nYour order has been received!',
		'はい': 'OK',
		'いいえ': 'Cancel',
		'合計': 'Total',
		'品': 'Goods',
		'注文を確認': 'Confirm Order',
		'メニューカテゴリ': 'Menu Category',
		'数量': 'Quantity',
		'商品': 'Product',
		'品の注文が未送信です': 'Product order has not been sent yet',
		'注文を確認する': 'Confirm Order',
		'ありがとうございました。\nしばらくお待ちください。': 'Thank you very much\nPlease wait',
		'注文を承りました': 'I received an order',
		"エラーが発生しました": "An error has occurred",
		'エラー': 'error',
		'数量が入力されていません。': 'The quantity has not been entered',
		'の数量があいません。': 'out of quantity',
		'システムエラー': 'System error',
		'エラーが発生しました。\nmissing table_id. need realod url': 'An error has occurred\nTable id not found.\nPlease reconnect.',
		'現在はオーダー履歴の閲覧ができません\n未着席状態': 'Currently unable to view order history \nNot seated',
		'お受け取り希望時間': 'Pick-up time',
		'時間を選択': 'Select time',
		'受け取り時間を選択してください': 'Please select a pick-up time',
		'通知方法': 'Notification type',
		'通知の受け取り方法を選択してください': 'Choose how you want to receive notifications',
		'メールアドレスを入力してください': 'Please enter your e-mail address',
		'メールアドレスの形式が正しくありません': 'Enter a valid email address',
		'メールアドレスは半角英数字・記号で入力してください': 'Please enter a email in half-width alphanumeric character or symbol',
		'電話番号を入力してください': 'Please enter a phone number',
		'電話番号を半角数字(ハイフン無し)で入力してください': 'Please enter the phone number in half-width numbers (without hyphens)',
		'備考がありましたら入力してください': 'Please enter any other requirements',
		'受け取り時間':'Pickup time',
		'お届け希望時間': 'Desired delivery time',
		'通知先':'Contact',
		'お名前':'Name',
		'配達可能エリア':'Delivery area',
		'お届け先の郵便番号': 'Postal code',
		'お届け先の住所': 'Address',
		'電話番号': 'Phone number',
		'備考':'Requirements',
		'合計金額':'Total',
		'追加する':'to add',
		'現在利用できません。':'Currently unavailable',
		'こちらの内容でお支払いします':'Would you\nlike to pay?',
		'必須項目を入力してください':'Please enter required fields',
		'希望時間が\n過ぎています':'Orderable time\nexceeded',
		'申し訳ございませんが、\n希望時間を再設定してください。':'Please select a pick-up time again.',
		'を開きます。よろしいですか？':'Open Is it OK?',
		'ご利用ありがとうございました\nまたのご利用をお待ちしております。':'Thank you for using \nWe look forward to your next use.',
		'受付番号': 'Reception number',
		'お会計が完了していません。': 'Checkout not completed',
		'ご利用ありがとうございました。': 'Thank you for using',
		'ご希望の受け取り時間': 'Desired pick-up time',
		'まだお店側が受け取り時間を設定していません。': 'The store has not yet set a pick-up time',
		'受け取り予定時間': 'Estimated receiving time',
		'指定のお時間に受け取りに来てください。そして受付番号をお伝えください。': 'Please come to pick up at the designated time. And please give the reception number',
		'準備完了の通知が届きましたら受け取りに来てください。そして受付番号をお伝えください。': 'Please come to pick up when you receive the notification of preparation. And please give the reception number',
		'更新':'update',
		'ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください':'Thank you for your order. Please wait for a while before serving food. \ nIf you need a receipt, please show this screen to the person in charge',
		'お受け取り希望時間を入力してください':'Please enter your desired pick-up time',
		'会計済みです':'Checked',
		'受け取り方法を選択してください': 'Please select a delivery method',
		'お店で受け取り': 'Pick up at the shop',
		'ご指定の住所にお届け': 'Deliver to your designated address',
		'ご希望の通知方法': 'Notification method',
		'お名前を入力してください': 'Please enter your name',
		'お名前は50文字以内で入力してください': 'Please enter your name within 50 characters',
		'お名前に記号は使用出来ません': 'You cannot use symbols in your name',
		'郵便番号を入力してください': 'Please enter your zip code',
		'郵便番号は半角数字で入力してください': 'Please enter the postal code in half-width characters',
		'郵便番号7桁で入力してください': 'Enter the postal code in 7 digits',
		'住所を入力してください': 'Please enter your address',
		'お支払い方法を選択してください': 'Please select the payment method',
		'ご希望のお届け時間': 'Desired delivery time',
		'まだお店側がお届け時間を設定していません。': 'The shop has not set delivery time',
    	'お届け予定時間': 'Estimated delivery time',
		'お届け希望時間を選択してください': 'Please select the desired delivery time',
		'配達料':'Delivery fee',
		'アプリ会員ID': 'App member ID',
		'アプリ会員IDを入力してください': 'Please enter the app member ID',
	}
}
export class Localization {


	loc: any;

	t(key: string) {
		if (!this.loc || this.loc.length < 1) return key;
		if (dictionary[this.loc] && dictionary[this.loc][key]) return dictionary[this.loc][key];
		return key;
	}
	setLoc(loc: string) {
		if (loc == "zh-CN") loc = "zh-Hans";
		else if (loc == "zh-TW") loc = "zh-Hant";
		else if (loc == "zh-TW") loc = "zh-Hant";
		else if (loc == "zh") loc = "zh-Hans";
		else {
			loc = loc.substr(0, 2);
		}
		this.loc = loc;
	}

}



// WEBPACK FOOTER //
// ./src/app/app.localization.ts